import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { AuthContext } from '@dashboard/context/AuthContext';

import AuthLayout from '@dashboard/layouts/AuthLayout';

import Button from '@dashboard/components/Button';

import { activateUser } from './helpers';

const propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default class Account extends Component {
  static contextType = AuthContext;

  state = {
    isActivating: !!this.props.match.params,
    isActivated: false,
    error: '',
  };

  componentDidMount() {
    const { activationToken } = this.props.match.params;
    const { user } = this.context;

    if (activationToken && !user.active) {
      this.activateUser(activationToken);
    }
  }

  activateUser = async activationToken => {
    const { token } = this.context;
    const response = await activateUser(activationToken, token);

    if (response.message) {
      this.setState({
        error: response.message,
        isActivating: false,
      });
    } else {
      this.setState({
        isActivated: true,
        isActivating: false,
        error: '',
      });
    }
  };

  render() {
    const { user } = this.context;
    const { isActivating, error, isActivated } = this.state;

    return (
      <AuthLayout>
        <div className="py-2">
          <div className="text-center m-auto">
            {!user.active ? (
              <React.Fragment>
                {isActivating && <h1 className="text-xl mb-2">Verifying your email address..</h1>}

                {error && error}

                {isActivated && (
                  <div>
                    <h1 className="text-xl mb-2">Your email address has been verified.</h1>

                    <div className="mt-4">
                      <Button to="/login" appearance="primary">
                        Sign in
                      </Button>
                    </div>
                  </div>
                )}
              </React.Fragment>
            ) : (
              <div>
                <h1 className="text-xl mb-2">Your email address has been verified.</h1>

                <div className="mt-4">
                  <Button to="/dashboard/pages" appearance="primary">
                    Go to dashboard
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </AuthLayout>
    );
  }
}

Account.propTypes = propTypes;
